export default __webpack_public_path__ + "images/8f8ee41775e9af5fee826c88faa02477-accessories_small.webp";